module.exports = __webpack_public_path__ + "assets/img/Cover.aa7e7377.jpg";